import { gql } from '@apollo/client';

export default gql`
  mutation DeleteCorporateDevice($id: Int!) {
    deleteCorporateDeviceById(input: { id: $id }) {
      deletedCorporateDeviceId
    }
  }
`;
